<template>
    <div class="qr-code"></div>
</template>

<script>
    export default {
        name: "QRCode"
    }
</script>

<style scoped lang="scss">

</style>
